var _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _feFlood, _feBlend, _feGaussianBlur;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgBackground = function SvgBackground(props) {
  var _id4 = useUniqueInlineId();
  var _id3 = useUniqueInlineId();
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 445,
    height: 580,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 445,
    height: 580,
    fill: "url(#".concat(_id, ")"),
    rx: 16
  }), /*#__PURE__*/React.createElement("mask", {
    id: "background_svg__c",
    width: 445,
    height: 580,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 445,
    height: 580,
    fill: "url(#".concat(_id2, ")"),
    rx: 8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#".concat(_id4, ")"),
    mask: "url(#background_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id3, ")"),
    d: "M242.189-17.684c148.55 1.635 267.358 149.731 265.365 330.782-1.992 181.051-124.031 326.497-272.581 324.862-148.55-1.635-267.358-149.731-265.365-330.782C-28.4 126.126 93.639-19.319 242.189-17.684Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 222.5,
    x2: 222.502,
    y1: 0.002,
    y2: 580,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102262"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101340"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 222.5,
    x2: 222.502,
    y1: 0.002,
    y2: 580,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102262"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101340"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: _id3,
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(46.919 -238.03 429.947) scale(324.077 596.48)",
    gradientUnits: "userSpaceOnUse"
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EA90"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.897,
    stopColor: "#001FC8",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("filter", {
    id: _id4,
    width: 797.996,
    height: 915.672,
    x: -160.417,
    y: -147.698,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  })), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_21921_36107",
    stdDeviation: 65
  })))));
};
export default SvgBackground;